import { cloneDeep, isEmpty } from 'lodash';
import React from 'react';

import Dialog from '@material-ui/core/Dialog';
import TextField from '@material-ui/core/TextField';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';

export default class ACPriceInputDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      price: 0,
      taxAmount: 0,
    };
    this.onChangeNumber = this.onChangeNumber.bind(this);
    this.onClickUpdate = this.onClickUpdate.bind(this);
  }

  componentWillReceiveProps(props) {
    let { price, taxAmount } = this.state;
    if (props.price) {
      price = props.price;
      this.setState({ price });
    }

    if (props.taxAmount) {
      taxAmount = props.taxAmount;
      this.setState({ taxAmount });
    }
  }

  onChangeNumber(key, value) {
    let { price, taxAmount } = cloneDeep(this.state);

    switch (key) {
      case 'price':
        price = value;
        break;
      case 'taxAmount':
        taxAmount = value;
        break;
      default:
        break;
    }

    this.setState({ price, taxAmount });
  }

  onClickUpdate() {
    const { price, taxAmount } = cloneDeep(this.state);

    let tax;
    if (!isEmpty(taxAmount)) {
      tax = { amount: taxAmount };
    }
    this.props.onClickUpdateFunc(price, tax);
  }

  CloseDialog() {
    this.props.onClickCancelFunc();
  }

  render() {
    const { price, taxAmount } = this.state;

    return (
      <Dialog
        open={this.props.open}
        aria-labelledby="form-dialog-title"
        fullWidth
        onEscapeKeyDown={this.props.onClickCancelFunc}
      >
        <DialogTitle id="form-dialog-title">
          <strong>Price &amp; Tax</strong>
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="notes"
            label="Price"
            type="number"
            fullWidth
            onChange={(e) => this.onChangeNumber('price', e.target.value)}
            value={price}
          />
          <TextField
            autoFocus
            margin="dense"
            id="notes"
            label="Tax Amount"
            type="number"
            fullWidth
            onChange={(e) => this.onChangeNumber('taxAmount', e.target.value)}
            value={taxAmount}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onClickCancelFunc} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={this.onClickUpdate}
            variant="contained"
            color="primary"
            style={{
              color: 'white',
            }}
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
